import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
const ProblemSection = lazy(() => import('../components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const WhatYouGet = lazy(() => import('../components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const UrgencySection = lazy(() => import('../components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const EliteSection = lazy(() => import('../components/EliteSection').then(m => ({
  default: m.EliteSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-black" data-id="element-275">
      <div data-id="element-276">
        <HeroSection data-id="element-277" />
        <SocialProofBar data-id="element-278" />

        <Suspense fallback={null} data-id="element-279">
          <ProblemSection data-id="element-280" />
          <SolutionSection data-id="element-281" />
          <WhatYouGet data-id="element-282" />
          <BonusSection data-id="element-283" />
          <UrgencySection data-id="element-284" />
          <PricingSection data-id="element-285" />
        </Suspense>

        <Suspense fallback={null} data-id="element-286">
          <EliteSection data-id="element-287" />
          <TestimonialsSection data-id="element-288" />
          <GuaranteeSection data-id="element-289" />
          <FAQSection data-id="element-290" />
          <FinalCTA data-id="element-291" />
          <Footer data-id="element-292" />
          <SocialProofPopup data-id="element-293" />
        </Suspense>
      </div>
    </main>;
}